import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { FilterService } from '../../../services/filter.service';
import { SublocationService } from '../../../services/sublocation.service';
import { Page } from '../../../models/paging/page';
import { UUID } from 'angular2-uuid';
import { SnotifyService } from 'ng-snotify';
import { ModalService } from '../../../services/modal.service';
import { LocationService } from '../../../services/location.service';

@Component({
  selector: 'app-sublocations',
  templateUrl: './sublocations.component.html',
  styleUrls: ['./sublocations.component.scss']
})
export class SublocationComponent implements OnInit {
  loading: boolean = false;
  readOnly: boolean = false;
  rows = [];
  page = new Page();
  company_Id;
  location_Id;
  location;
  user;
  filter: any = {
    company_Id: undefined,
    name: '',
  };
  default_filters = JSON.parse(JSON.stringify(this.filter));
  constructor(private locationService: LocationService, public router: Router, private authService: AuthService, private filterService: FilterService,
    private modalService: ModalService, private snotifyService: SnotifyService
  ) {
    this.user = this.authService.currentUser.value;
    this.filter.company_Id = this.router.parseUrl(this.router.url).queryParams["company_Id"];
    this.company_Id = this.router.parseUrl(this.router.url).queryParams["company_Id"];
    this.filter.location_Id = this.router.parseUrl(this.router.url).queryParams["location_id"];
    this.location_Id = this.router.parseUrl(this.router.url).queryParams["location_id"];

    if (this.authService.currentUser.value.userProfileId != 1 && this.authService.currentUser.value.userProfileId != 4) {
      this.readOnly = true;
    }

    if (this.authService.currentUser.value.userProfileId == 3) {
      //user is a client, so throw them to the reports page
      this.router.navigate(['']);
    }

    this.page.pageNumber = 0;
    this.page.size = 10;
    this.page.sortOrder = 'asc';
    this.page.sortBy = "name";


    //console.log(this.id);
    if (this.location_Id != null) {

      this.locationService.getById(this.location_Id).then((loc) => {
        //console.log(loc);
        this.location = loc;
      });
    }

    var filters = this.filterService.getFilters(this.authService.currentUser.value.id, this.router.url);
    if (filters != null) {
      this.filter = filters;
      this.loadTable()
    }
  }

  ngOnInit(): void {
    this.loadTable();
  }

  loadTable() {
    this.loading = true;
    this.locationService.getSublocationTable(this.page, this.filter.location_Id, this.filter.name).then((rows) => {
      //console.log(rows);
      this.page = rows.page;
      this.rows = rows.data;
      this.loading = false;
    });
  }

  rebind() {
    this.loadTable();
  }

  resetFilters() {
    this.filter = this.filterService.parseFilters(JSON.stringify(this.default_filters));
    this.filter.company_Id = this.company_Id;
    this.filter.location_Id = this.location_Id;
    this.loadTable();
  }

  setPage(pageInfo) {
    this.page.pageNumber = pageInfo.offset;

    this.loadTable();
  }

  onSort(event) {
    if (event.column.prop == '') {
      return false;
    }
    this.loadTable();

  }

  openModal(id) {
    this.modalService.open(id);
  }
  cancelModal(id) {
    this.modalService.close(id);
    this.loadTable();
  }

  sublocationId;
  subLocationName;
  archived: boolean = false;
  editing;
  add() {
    this.editing = false;
    this.sublocationId = UUID.UUID();
    this.subLocationName = undefined;
    this.archived = false;
    this.openModal('popup-sublocation-add');
  }

  saveSubLocation() {
    if (this.subLocationName == undefined || this.subLocationName == null || this.subLocationName == "") {
      this.snotifyService.error("Please enter a name");
      return;
    }
    var sublocation = {
      id: this.sublocationId,
      name: this.subLocationName,
      location_Id: this.location_Id,
      userId: this.user.id,
      archived: this.archived
    }

    this.locationService.savesublocation(sublocation).then((data) => {

      this.subLocationName = undefined;
      this.sublocationId = undefined;
      this.archived = false;
      this.cancelModal('popup-sublocation-add');
    });
  }

  edit(row) {
    this.editing = true;
    this.sublocationId = row.id;
    this.subLocationName = row.name;
    this.archived = row.archived;;
    this.openModal('popup-sublocation-add');
  }

  back() {
    this.router.navigate(['admin/locations/'], { queryParams: { id: this.company_Id } });
  }
  getRowClass = (row) => {
    return {
      'row-expired': row.archived,
      'row': true
    }
  }
}
